import ValidationResult from "./validation-result";
import HttpError from "./http-error";
import HttpFetchStatus from "../../enums/api/http-fetch-status";


interface RestSet {
  postStatus: HttpFetchStatus;
  postError: HttpError | ValidationResult[] | null;
  patchId: string | null;
  patchStatus: HttpFetchStatus;
  patchError: HttpError | ValidationResult[] | null;
  getStatus: HttpFetchStatus;
  getError: HttpError | null;
  deleteStatus: HttpFetchStatus;
  deleteError: HttpError | ValidationResult[] | null;
}

export const defaultRestSet = {
  postStatus: HttpFetchStatus.Idle,
  postError: null,
  patchId: null,
  patchStatus: HttpFetchStatus.Idle,
  patchError: null,
  getStatus: HttpFetchStatus.Idle,
  getError: null,
  deleteStatus: HttpFetchStatus.Idle,
  deleteError: null,
} as RestSet;

export default RestSet

export interface OneToOneRestSet {
  patchStatus: HttpFetchStatus;
  patchError: HttpError | ValidationResult[] | null;
  getStatus: HttpFetchStatus;
  getError: HttpError | null;
}

export const defaultOneToOneRestSet = {
  patchStatus: HttpFetchStatus.Idle,
  patchError: null,
  getStatus: HttpFetchStatus.Idle,
  getError: null,
}; 

export const mockFullRestSet = {
  deleteError: { code: "400", message: "failed", value: "value" },
  deleteStatus: HttpFetchStatus.Failed,
  getError: { code: "400", message: "failed", value: "value" },
  getStatus: HttpFetchStatus.Failed,
  patchError: { code: "400", message: "failed", value: "value" },
  patchId: "someId",
  patchStatus: HttpFetchStatus.Failed,
  postError: { code: "400", message: "failed", value: "value" },
  postStatus: HttpFetchStatus.Failed,
} as RestSet;

export const successResetResponse = (restSet: Partial<RestSet>) => {
  const updatedRestSet = {
    postStatus: restSet.postStatus === HttpFetchStatus.Success ? HttpFetchStatus.Idle : undefined,
    postError: restSet.postStatus === HttpFetchStatus.Success ? null : undefined,
    patchStatus: restSet.patchStatus === HttpFetchStatus.Success ? HttpFetchStatus.Idle : undefined,
    patchError: restSet.patchStatus === HttpFetchStatus.Success ? null : undefined,
    deleteStatus: restSet.deleteStatus === HttpFetchStatus.Success ? HttpFetchStatus.Idle : undefined,
    deleteError: restSet.deleteStatus === HttpFetchStatus.Success ? null : undefined,
  } as Partial<RestSet>;
  return Object.fromEntries(Object.entries(updatedRestSet).filter(([_, v]) => v !== undefined));
};

export const errorResetResponse = (restSet: Partial<RestSet>) => {
  const updatedRestSet = {
    postStatus: restSet.postStatus === HttpFetchStatus.Failed ? HttpFetchStatus.Idle : undefined,
    postError: restSet.postStatus === HttpFetchStatus.Failed ? null : undefined,
    patchStatus: restSet.patchStatus === HttpFetchStatus.Failed ? HttpFetchStatus.Idle : undefined,
    patchError: restSet.patchStatus === HttpFetchStatus.Failed ? null : undefined,
    deleteStatus: restSet.deleteStatus === HttpFetchStatus.Failed ? HttpFetchStatus.Idle : undefined,
    deleteError: restSet.deleteStatus === HttpFetchStatus.Failed ? null : undefined,
  } as Partial<RestSet>;
    return Object.fromEntries(Object.entries(updatedRestSet).filter(([_, v]) => v !== undefined));
};

export const isSuccessSetOpen = (restSet: RestSet) => {
  return (
    restSet.postStatus === HttpFetchStatus.Success ||
    restSet.patchStatus === HttpFetchStatus.Success ||
    restSet.deleteStatus === HttpFetchStatus.Success
  );
};

export const isErrorSetOpen = (restSet: RestSet) => {
  return (
    restSet.postStatus === HttpFetchStatus.Failed ||
    restSet.patchStatus === HttpFetchStatus.Failed ||
    restSet.deleteStatus === HttpFetchStatus.Failed
  );
};